import { Observable } from 'rxjs';
import { AjaxConfig, AjaxResponse } from 'rxjs/ajax';

import { HttpHandler } from 'app/http/http-handler';
import { Interceptor } from 'app/http/interceptor';
import { AppStore } from 'app/store';
import { selectActiveTaxonomies } from 'features/auth/auth.slice';

export class TaxonomyHeaderInterceptor implements Interceptor {
    public intercept<T>(store: AppStore, req: AjaxConfig, next: HttpHandler<T>): Observable<AjaxResponse<T>> {
        req.headers = {
            'x-txm-source-id': selectActiveTaxonomies(store.getState())
                ?.map(({ id }) => id)
                .join(','),
            ...req.headers,
        };

        return next.handle(req);
    }
}
